class Breadcrumb {
    constructor() {
        this.storageKey = 'hugrug:fromCollection';
        this.excludedHandles = ['all'];
        
        this.bindProductLinkTracking();
        this.updateProductBreadcrumb();
    }

    bindProductLinkTracking() {
        document.addEventListener('click', (e) => this.onProductLinkClick(e), true);
        document.addEventListener('auxclick', (e) => this.onProductLinkClick(e), true);
    }

    onProductLinkClick(e) {
        const link = e.target.closest('a[href]');
        if (!link || !this.isProductLink(link)) return;

        const container = link.closest('[data-from-collection]');
        const fromCollection =
            link.dataset.fromCollection || container?.dataset.fromCollection;

        if (fromCollection) {
            try {
                sessionStorage.setItem(this.storageKey, fromCollection);
            } catch {}
        } else {
            try {
                sessionStorage.removeItem(this.storageKey);
            } catch {}
        }
    }

    isProductLink(link) {
        try {
            const url = new URL(link.href, window.location.origin);
            return url.pathname.includes('/products/');
        } catch {
            return false;
        }
    }

    referrerCollectionHandle() {
        try {
            const ref = new URL(document.referrer);
            if (ref.origin !== window.location.origin) return null;

            const match = ref.pathname.match(/\/collections\/([^/]+)/);
            if (!match) return null;
            if (ref.pathname.includes('/products/')) return null;
            if (this.excludedHandles.includes(match[1])) return null;

            return match[1];
        } catch {
            return null;
        }
    }

    storedCollectionHandle() {
        try {
            return sessionStorage.getItem(this.storageKey);
        } catch {
            return null;
        }
    }

    consumeStoredCollectionHandle() {
        const handle = this.storedCollectionHandle();
        try {
            sessionStorage.removeItem(this.storageKey);
        } catch {}
        return handle;
    }

    collectionCrumbs() {
        const jsonEl = document.getElementById('product-collection-crumbs');
        if (!jsonEl) return [];

        try {
            const crumbs = JSON.parse(jsonEl.textContent);
            return Array.isArray(crumbs) ? crumbs : [];
        } catch {
            return [];
        }
    }

    updateProductBreadcrumb() {
        const list = document.querySelector('[data-product-breadcrumb]');
        if (!list) return;

        const handle = this.referrerCollectionHandle() || this.storedCollectionHandle();
        this.consumeStoredCollectionHandle();

        if (!handle || this.excludedHandles.includes(handle)) return;

        const fromCollection = this.collectionCrumbs().find((crumb) => crumb.handle === handle);
        if (!fromCollection) return;

        list.querySelectorAll('.js-default-crumb').forEach((el) => el.remove());

        const homeItem = list.querySelector('li');
        if (!homeItem) return;

        let insertAfter = homeItem;

        if (fromCollection.parent && fromCollection.parent.title && fromCollection.parent.url) {
            const parentItem = this.crumbItem(fromCollection.parent.url, fromCollection.parent.title);
            insertAfter.after(parentItem);
            insertAfter = parentItem;
        }

        insertAfter.after(this.crumbItem(fromCollection.url, fromCollection.title));
    }

    crumbItem(href, title) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = href;
        a.className = 'breadcrumb-link';
        a.title = title;
        a.textContent = title;
        li.appendChild(a);
        return li;
    }
}
